function showInlineNotification($area, notifyType, message, description) {
    const variant = notifyType === 'success' ? 'success' : (notifyType === 'error' ? 'danger' : 'info');
    const $alert = $('<div class="alert alert-dismissible inline-notification" role="alert"></div>')
        .addClass('alert-' + variant)
        .append($('<span></span>').text(message));

    if (description) {
        $alert.append($('<div></div>').text(description));
    }

    $alert.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
    $area.empty().append($alert);
    $area[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

export function notification(notifyType, message, description) {
    const $inlineArea = $('.js-inline-notification-area').first();

    if ($inlineArea.length) {
        showInlineNotification($inlineArea, notifyType, message, description);

        return;
    }

    function showNotification() {
        setTimeout(function () {
            $('.notification').slideDown('slow');
        }, 1000);
    }
    function hideNotification() {
        setTimeout(function () {
            $('.notification').slideUp('slow');
        }, 5000);
        setTimeout(function () {
            $('.notification').remove();
        }, 6000);
    }

    if(!description) {
        description = `Thank you for using ` + $('#app').data('name');
    }

    $('body').prepend(`
        <div class="notification ${notifyType}">
            <div class="notification-header">
                <h5 class="notification-title">${message}</h5>
            </div>
            <div class="delimiter"></div>
            <div class="notification-body">
                <p class="notification-text">${description}</p>
            </div>
        </div>
    `);

    showNotification()
    hideNotification()
}
